import { CHECK_PAYMENT_CODE } from '../redux/constants';
import { createSelector } from 'reselect';
import { getPaymentCheck } from '../redux/selectors';

export default createSelector(getPaymentCheck, (paymentCheck) => {
  const { data } = paymentCheck;
  const paymentCheckResultCode = data?.code;

  // По умолчанию задизейблено
  if (!paymentCheckResultCode) {
    return true;
  }

  const possibleStatuses = [
    CHECK_PAYMENT_CODE.OPERATION_LIMIT_REACHED,
    CHECK_PAYMENT_CODE.MONTH_LIMIT_REACHED,
  ] as string[];

  return possibleStatuses.includes(paymentCheckResultCode);
});
